import {
  always,
  both,
  includes,
  lt,
  propEq,
  propSatisfies,
  reject,
  when,
} from 'ramda';

import featureToggles from '@/config/feature-toggles';
import { type Region, type WebCohort } from '@/types';

type CohortFilterFn = (c: WebCohort[]) => WebCohort[];

// The Masters feature is to brand part-time courses as a "master" degree.
// Therefore, part-time courses are hidden and interacted with in other pages.
// This only applies when the feature is active and for certain regions.

const MASTERS_CUTOFF_DATE = '2025-03-03' as const;

const mastersRegions: readonly Region[] = ['es'] as const;

export const isMastersActive = (region: Region): boolean =>
  featureToggles['hide-part-time-for-masters'] &&
  includes(region, mastersRegions);

export const excludePartTimeCoursesForMasters = (
  region: Region
): CohortFilterFn =>
  when<WebCohort[], WebCohort[]>(
    always(isMastersActive(region)),
    reject(
      both(
        propEq('format', 'pt'),
        // @ts-expect-error: No typing for lt with strings
        propSatisfies(lt(MASTERS_CUTOFF_DATE), 'start_date')
      )
    )
  );
